<div class="weekly-reports-page records-page datatable-page-shell">
    <div class="records-page__hero weekly-reports-hero">
        <div class="records-page__hero-primary">
            <div class="records-page__hero-headline">
                <span class="records-page__hero-eyebrow">{{ 'REPORTS' | translate }}</span>
                <h3 class="records-page__hero-title">{{ 'WEEKLY_REPORTS' | translate }}</h3>
            </div>
        </div>
    </div>

    <div class="details-tab-surface weekly-reports-surface datatable-page-surface">
        <div *ngIf="Error" class="weekly-reports-error text-danger">
            {{ Error }}
        </div>
        <div class="weekly-reports-controls">
            <div class="form-group row">  
                <label class="col col-12 text-danger">{{ 'WEEKLY_REPORTS_ADMIN_ONLY_SECTION_WARNING' | translate }}</label>
                <label class="col col-12 text-danger">{{ 'WEEKLY_REPORTS_REPORTS_WILL_ONLY_SEND_TO_SPECIFIED_WARNING' | translate }}</label>
            </div> 
            <div class="form-group row">
                <label class="col col-auto">{{ 'SEND_TO_EMAIL_ADDRESS' | translate }}:</label>
                <div class="col col-3 weekly-reports-input-col">
                    <input type="email" multiple class="form-control" [(ngModel)]="ToEmails" autofocus #toEmailElement />
                </div>
                <label class="col col-auto">{{ 'CC_EMAIL_ADDRESSES' | translate }}:</label>
                <div class="col col-4 weekly-reports-input-col">
                    <input type="email" multiple class="form-control" [(ngModel)]="CCEmails" />
                </div>
            </div> 
        </div>
        <div class="weekly-reports-table-wrap">
            <app-campaign-datatable class="records-page__table" [iCanRead]="true" [iColumns]="adsReportsTableColumns" [iShowExport]="false"
                [iData$]="adsReportsTableData" [iPageSize]="100" [iShowSendEmail]="true"
                (oSendEmail)="oSendEmail($event)"></app-campaign-datatable>
        </div>
    </div>
</div>